import { render, staticRenderFns } from "./ScheckboxEditor.vue?vue&type=template&id=c1fe4572&"
import script from "./ScheckboxEditor.vue?vue&type=script&lang=js&"
export * from "./ScheckboxEditor.vue?vue&type=script&lang=js&"
import style0 from "./ScheckboxEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports